import React, { createContext, useContext, useMemo } from "react";
import { useApiQuery } from "../hooks/use-api";
import { SchemaModel } from "../models/schema";
import { useAccess } from "./access-provider";
import { parseOpenAPIToSchema } from "./openapi-parser";
import logger from "./logger";

export const ApiSchemaContext = createContext<{
  apiSchema?: SchemaModel;
}>({
  apiSchema: undefined,
});

export const useApiSchema = () => useContext(ApiSchemaContext);

export const ApiSchemaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { accessToken } = useAccess();

  // Récupération du fichier OpenAPI depuis l'endpoint /openapi.json
  const { data: openApiSpec } = useApiQuery<any>(
    {
      url: "/openapi.json",
      params: {
        light: true,
      },
    },
    { enabled: !!accessToken }
  );

  // Parse du fichier OpenAPI pour extraire les sources et trackers
  const schema = useMemo(() => {
    if (!openApiSpec) return undefined;

    try {
      return parseOpenAPIToSchema(openApiSpec);
    } catch (error) {
      logger.error("Erreur lors du parsing du fichier OpenAPI:", error);
      return undefined;
    }
  }, [openApiSpec]);

  return (
    <ApiSchemaContext.Provider value={{ apiSchema: schema }}>
      {children}
    </ApiSchemaContext.Provider>
  );
};
